import { service, service1 } from "@/request/request";


//发送短信
export const smsCode = (data) => {
    return service({
        url: "/smsCode",
        method: "post",
        data: data,
    });
};

//注册
export const SubmitRegister = (data) => {
    return service({
        url: "/register",
        method: "post",
        data: data,
    });
};